import { useNavigate } from "react-router-dom";
import { useEffect } from 'react';

const Logoff = (props) => {

 const navigate = useNavigate();
  useEffect(() => {
    console.log("Loggoff ");
    props.newToken("");
    props.newUsrId(0);
    props.newUsrGrupo(0);
    props.newUsrName("");

    props.onShow(); 
    
     navigate("/");
     }, []);
             
return (
    <>
    <div> 
        </div>
        </>
  );
}

export default Logoff;
